import { BasketballCoachLog, CustomTableColumn } from '@hefe/models';
import { BasketballCoachLoggingSlice } from '@hefe/store';
import { formatDate } from '@hefe/utils';
import { t } from '@hefe/i18n';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../store/store';
import CustomTable from '../../../core/components/table/custom-table.component';
import CoachLoggingMoreActionsComponent from '../../components/coach-logging-more-actions/coach-logging-more-actions.component';
import AddCoachLogForm from '../../forms/add-coach-log.form';

export default function CoaachLoggingPage() {
  const dispatch = useAppDispatch();
  const logs = useSelector(
    BasketballCoachLoggingSlice.basketballCoachLogsSelector
  );

  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    fetchLogs();
  }, []);

  const fetchLogs = () => {
    setLoading(true);
    dispatch(BasketballCoachLoggingSlice.fetchBasketballCoachLogging())
      .unwrap()
      .catch(() => null)
      .finally(() => setLoading(false));
  };

  const columns: CustomTableColumn[] = [
    {
      title: t('date'),
      dataIndex: 'date',
      key: 'date',
      showDateFilter: true,
      sortType: 'date',
      default: true,
      render: (v: string) => formatDate(v),
    },
    {
      title: t('team'),
      dataIndex: ['team', 'name'],
      key: 'team',
      sortType: 'string',
      showFilter: true,
      default: true,
    },
    {
      title: t('note'),
      dataIndex: 'note',
      key: 'note',
      sortType: 'string',
      default: true,
    },
    {
      title: '...',
      key: 'more',
      default: true,
      render: (item: BasketballCoachLog) => {
        return <CoachLoggingMoreActionsComponent log={item} />;
      },
    },
  ];

  return (
    <CustomTable
      rowKey={'id'}
      name="coach-logging"
      dataSource={logs}
      columns={columns}
      loading={loading}
      addForm={{
        formId: 'add-coach-log',
        title: t('add_coach_logging'),
        component: <AddCoachLogForm />,
      }}
    />
  );
}
